import styled, { css } from 'styled-components';

export const SortingWrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: baseline;

  > div {
    height: 48px;
  }
`;

const gridTableCol = css`
  --padding-inline: 24px;

  display: grid;
  grid-template-columns: 100px repeat(8, 1fr);
  gap: 24px;
  padding-inline: var(--padding-inline);
`;

export const Legend = styled.div`
  ${gridTableCol}
  margin-bottom: 24px;
  align-items: center;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  > *:last-child {
    margin-right: calc(var(--padding-inline) * -1);
  }
`;

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-bottom: 64px;
`;

export const ActivityCard = styled.div`
  ${gridTableCol}
  padding-block: 38px;
  margin-bottom: 16px;
  height: 100px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CompletionWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  .statistics-heading {
    max-width: 75px;
  }

  svg {
    margin-top: -4px; //center to text
  }
`;
